module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _vm._v("NEW YORK UNIVERSITY PRESS")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("New York and London")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.nyupress.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nyupress.org")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("© 2015 by New York University")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("References to Internet websites (URLs) were accurate at the time of writing. Neither the author nor New York University Press is responsible for URLs that may have expired or changed since the manuscript was prepared.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Marbury, Herbert Robinson.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Pillars of cloud and fire : the politics of exodus in African American biblical interpretation / Herbert Robinson Marbury.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("pages cm Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN 978-1-4798-3596-6 (cloth : alk. paper) — ISBN 978-1-4798-1250-9 (paper : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("1. Black theology. 2. Bible—Black interpretations. 3. Exodus, The—Typology. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("BT82.7.M356 2015")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("230.089’96073—dc23  2015010013")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability. We strive to use environmentally responsible suppliers and materials to the greatest extent possible in publishing our books.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Also available as an ebook")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c4efb9f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Marbury-0004.vue
// module id = 63
// module chunks = 0